import { render, staticRenderFns } from "./GroupNew.vue?vue&type=template&id=9c65d2e0"
import script from "./GroupNew.vue?vue&type=script&lang=js"
export * from "./GroupNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports